import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Tooltip,
  Paper,
  Typography,
  alpha,
  Divider,
} from '@mui/material';
import {
  Save as SaveIcon,
  Restore as RestoreIcon,
  Info as InfoIcon,
  Rocket as RocketIcon
} from '@mui/icons-material';

// Componente para os botões de salvar e restaurar configurações
const ConfiguracoesFooter = ({ 
  resetarConfiguracoes, 
  salvarConfiguracoes, 
  salvando,
  customTheme,
  criarTemplateJsonExemplo
}) => {
  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 2, 
        borderRadius: 2,
        border: '1px solid',
        borderColor: theme => alpha(theme.palette.divider, 0.1),
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Adicionar nota informativa sobre o salvamento do template */}
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          mb: 2,
          p: 1.5,
          borderRadius: 1,
          backgroundColor: alpha(customTheme?.palette.info.main || '#2196f3', 0.08)
        }}
      >
        <InfoIcon 
          fontSize="small" 
          sx={{ 
            color: customTheme?.palette.info.main || '#2196f3',
            mr: 1
          }} 
        />
        <Typography variant="body2" color="text.secondary">
          As alterações feitas no estilo dos elementos serão automaticamente aplicadas ao template HTML.
          Clique em "Salvar Configurações" para persistir no servidor.
        </Typography>
      </Box>
      
      {/* 🆕 NOVA SEÇÃO PARA TEMPLATE JSON */}
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          mb: 2,
          p: 1.5,
          borderRadius: 1,
          backgroundColor: alpha('#4caf50', 0.08),
          border: '1px solid',
          borderColor: alpha('#4caf50', 0.2)
        }}
      >
        <RocketIcon 
          fontSize="small" 
          sx={{ 
            color: '#4caf50',
            mr: 1
          }} 
        />
        <Typography variant="body2" color="text.secondary">
          <strong>🚀 NOVO:</strong> Experimente o sistema de templates JSON estruturados! 
          Muito mais rápido e confiável que HTML (80-90% de melhoria na performance).
        </Typography>
      </Box>
      
      <Divider sx={{ mb: 2 }} />
      
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 1
        }}
      >
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Tooltip title="Restaurar todas as configurações para os valores padrão">
            <Button
              color="error"
              variant="outlined"
              onClick={resetarConfiguracoes}
              startIcon={<RestoreIcon />}
              sx={{ minWidth: '150px' }}
            >
              Resetar Configurações
            </Button>
          </Tooltip>
          
          {/* 🆕 BOTÃO PARA CRIAR TEMPLATE JSON */}
          {criarTemplateJsonExemplo && (
            <Tooltip title="Criar um template JSON de exemplo com performance superior">
              <Button
                color="success"
                variant="outlined"
                onClick={criarTemplateJsonExemplo}
                disabled={salvando}
                startIcon={<RocketIcon />}
                sx={{ 
                  minWidth: '180px',
                  borderColor: '#4caf50',
                  color: '#4caf50',
                  '&:hover': {
                    borderColor: '#388e3c',
                    backgroundColor: alpha('#4caf50', 0.04)
                  }
                }}
              >
                🚀 Criar Template JSON
              </Button>
            </Tooltip>
          )}
        </Box>
        
        <Tooltip title="Salvar todas as configurações no servidor">
          <Button
            color="primary"
            variant="contained"
            onClick={salvarConfiguracoes}
            disabled={salvando}
            startIcon={salvando ? <CircularProgress size={20} /> : <SaveIcon />}
            sx={{ minWidth: '180px' }}
          >
            {salvando ? 'Salvando...' : 'Salvar Configurações'}
          </Button>
        </Tooltip>
      </Box>
    </Paper>
  );
};

export default ConfiguracoesFooter; 